const aiGeneratorEnglish = {
  header: {
    title: "AI Post Generator",
    description: "Let AI help you create engaging LinkedIn posts based on your preferences"
  },
  customerBanner: {
    working: "You are now generating posts for"
  },
  loading: {
    posts: "Loading your latest AI-generated posts..."
  },
  noPosts: {
    title: "No posts found",
    description: "Your system automatically generates new LinkedIn posts for you each week. When AI generates your posts, they will appear here, where you can edit and schedule them.",
    settings: "If you don't want to wait, you can go to",
    settingsLink: "Settings",
    settingsAfter: "to change your preferences."
  },
  post: {
    author: "LinkedIn User",
    time: "Now •",
    editHint: "Press Ctrl+Enter to save, Esc to cancel"
  },
  stats: {
    likes: "0",
    comments: "0",
    shares: "0"
  },
  aiPrompt: {
    placeholder: "Describe how the post should be improved...",
    editing: "Editing",
    send: "Send"
  },
  buttons: {
    retry: "Try again",
    generating: "Generating",
    removeImage: "Remove image",
    nextImage: "Next",
    addImage: "Image",
    accept: "Accept",
    scheduling: "Scheduling...",
    calculatingTimes: "Calculating times...",
    noAvailableTimes: "No available times"
  },
  gallery: {
    title: "Select an image",
    noImages: "You have no images in your archive.",
    goToArchive: "Go to image archive"
  },
  imageOptions: {
    title: "Add image",
    gallery: "Choose from image archive",
    upload: "Upload new image",
    camera: "Take photo",
    manage: "Manage image archive"
  },
  messages: {
    imageUpdated: "Image updated!",
    imageRemoved: "Image removed!",
    savedChanges: "Changes saved!",
    regenerated: "The post has been regenerated!",
    updated: "The post has been updated!",
    newPost: "New post created!",
    accepted: "Your post has been accepted and moved to \"My Posts\", where you can schedule it for sharing on LinkedIn!",
    calculatingTimes: "Calculating available times...",
    noScheduledTimes: "There are no scheduled times set in your scheduler. Go to Scheduler to set up times.",
    postScheduled: "Post scheduled for {formattedDate}",
    imageUploaded: "Image uploaded and added to your post!",
    error: "An error occurred. Please try again later."
  }
};

export default aiGeneratorEnglish; 